import { render } from "./Pools.vue?vue&type=template&id=392b23d2"
import script from "./Pools.vue?vue&type=script&lang=js"
export * from "./Pools.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__